import { produce } from "immer";
import {
  FETCH_ENQUIRIES,
  FETCH_ENQUIRIES_SUCCESS,
  FETCH_ENQUIRIES_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_ENQUIRY,
  ADD_ENQUIRY_SUCCESS,
  ADD_ENQUIRY_FAILURE,
  //
  EDIT_ENQUIRY,
  EDIT_ENQUIRY_SUCCESS,
  EDIT_ENQUIRY_FAILURE,
  //
  DELETE_ENQUIRY,
  DELETE_ENQUIRY_SUCCESS,
  DELETE_ENQUIRY_FAILURE,
  //
  DELETE_ENQUIRY_NOTE,
  DELETE_ENQUIRY_NOTE_FAILURE,
  DELETE_ENQUIRY_NOTE_SUCCESS,
  //
  DELETE_ENQUIRY_REMINDER_NOTE,
  DELETE_ENQUIRY_REMINDER_NOTE_FAILURE,
  DELETE_ENQUIRY_REMINDER_NOTE_SUCCESS,
  //
  OPEN_NOTE_ADD_MODAL,
  CLOSE_NOTE_ADD_MODAL,
  //
  OPEN_REMINDER_ADD_MODAL,
  CLOSE_REMINDER_ADD_MODAL,
  //
  ADD_NOTE,
  ADD_NOTE_SUCCESS,
  ADD_NOTE_FAILURE,
  //
  GET_NOTES,
  GET_NOTES_FAILURE,
  GET_NOTES_SUCCESS,
  //
  ADD_REMINDER,
  ADD_REMINDER_SUCCESS,
  ADD_REMINDER_FAILURE,
  //
  GET_REMINDERS,
  GET_REMINDERS_FAILURE,
  GET_REMINDERS_SUCCESS,
  //
  GET_TIMELINE,
  GET_TIMELINE_SUCCESS,
  GET_TIMELINE_FAILURE,
  //
  TOGGLE_EVENT_MODAL,
  //
  ADD_EVENT,
  ADD_EVENT_SUCCESS,
  ADD_EVENT_FAILURE,
  //
  GET_STATS,
  GET_STATS_SUCCESS,
  GET_STATS_FAILURE,
  //
  TOGGLE_ADDRESS_MODAL,
  TOGGLE_ATTORNEY_MODAL,
  TOGGLE_ASSIGN_MODAL,
  //
  TOGGLE_SCHEDULE_MODAL,
  TOGGLE_OUTCOME_MODAL,
  TOGGLE_REMINDER_MODAL,
  TOGGLE_CLOSE_MODAL,
  TOGGLE_DOC_MODAL,
  TOGGLE_OTHER_MODAL,
  TOGGLE_EXIST_MODAL,
  //
  SAVE_DOCS,
  SAVE_DOCS_SUCCESS,
  SAVE_DOCS_FAILURE,
  //
  SAVE_OUTCOME,
  SAVE_OUTCOME_SUCCESS,
  SAVE_OUTCOME_FAILURE,
  //
  SAVE_CLOSE,
  SAVE_CLOSE_SUCCESS,
  SAVE_CLOSE_FAILURE,
  //
  SET_VIEW,
  //
  SEARCH_EMAIL,
  SEARCH_EMAIL_SUCCESS,
  SEARCH_EMAIL_FAILURE,
  //
  SEARCH_CONTACT,
  SEARCH_CONTACT_SUCCESS,
  SEARCH_CONTACT_FAILURE,
  //
  EDIT_OUTCOME,
  EDIT_OUTCOME_SUCCESS,
  EDIT_OUTCOME_FAILURE,
  //
  GET_ENQ_CHART,
  GET_ENQ_CHART_SUCCESS,
  GET_ENQ_CHART_FAILURE,
  //
  GET_CL_REPORT,
  GET_CL_REPORT_SUCCESS,
  GET_CL_REPORT_FAILURE,
  //
  GET_AQ_REPORT,
  GET_AQ_REPORT_SUCCESS,
  GET_AQ_REPORT_FAILURE,
  //
  GET_REF_REPORT,
  GET_REF_REPORT_SUCCESS,
  GET_REF_REPORT_FAILURE,
  SET_REPORT,
  //
  GET_TYPE_REPORT,
  GET_TYPE_REPORT_SUCCESS,
  GET_TYPE_REPORT_FAILURE,
  //
  GET_MAP_REPORT,
  GET_MAP_REPORT_SUCCESS,
  GET_MAP_REPORT_FAILURE,
  //
  GET_MY_TASK,
  GET_MY_TASK_SUCCESS,
  GET_MY_TASK_FAILURE,
  //
  SEARCH_USER,
  SEARCH_USER_SUCCESS,
  SEARCH_USER_FAILURE,
  //
  GET_COUNTY,
  GET_COUNTY_SUCCESS,
  GET_COUNTY_FAILURE,
  //
  UPDATE_DONE,
  UPDATE_DONE_SUCCESS,
  UPDATE_DONE_FAILURE,
  //
  SET_DIGITAL_DATA,
  SET_RECOMM_DATA,
  SET_LOCAL_DATA,
  SET_ADVERT_DATA,
} from "./constants";

export const initialState = {
  isFetchingEnquiries: false,
  isFetchingEnquiriesNotes: false,
  isFetchingEnquiriesReminders: false,
  enquiries: [],
  enquiriesNotes: [],
  enquiriesReminders: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentEnquiry: {},
  currentEnquiryNote: {},
  currentEnquiryReminder: {},
  // Delete
  isDeleting: false,
  isNoteAddModalOpen: false,
  isReminderAddModalOpen: false,
  //
  isFetchingTimeline: false,
  currentTimeline: [],
  //
  eventModal: { open: false },
  //
  isAddingEvent: false,
  isGettingStats: false,
  stats: {},
  //
  outcomeModal: { open: false },
  addressModal: { open: false },
  attorneyModal: { open: false },
  assignModal: { open: false },

  //
  scheduleModal: { open: false },
  reminderModal: { open: false },
  closeModal: { open: false },
  docModal: { open: false },
  view: "default",
  isSearchingContacts: false,
  contactList: [],
  isSearchingEmail: false,
  emailList: [],
  otherModal: {
    open: false,
  },
  reportStage: {
    list: [],
    type: "default",
  },
  aqReport: [],
  refReport: [],
  refTypeReport: {},
  mapReport: {
    map: [],
  },
  isGettingMap: false,
  isGettingTask: false,
  myTask: {},

  //
  existModal: {
    open: false,
  },
  isSearchingUser: false,
  userList: [],
  //
  countyList: [],
  isGettingCounty: false,
  //
  isUpdatingDone: false,
  //
  digitalData: [],
  recommData: [],
  localData: [],
  advertData: [],
};

const EnquiriesReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_ENQUIRIES:
        draft.isFetchingEnquiries = true;
        draft.currentEnquiry = {};
        break;
      case FETCH_ENQUIRIES_SUCCESS:
        draft.isFetchingEnquiries = false;
        draft.enquiries = action.payload;
        break;
      case FETCH_ENQUIRIES_FAILURE:
        draft.isFetchingEnquiries = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentEnquiry = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentEnquiry = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_ENQUIRY:
        draft.isSubmitting = true;
        break;
      case ADD_ENQUIRY_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_ENQUIRY_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_ENQUIRY:
        draft.isSubmitting = true;
        break;
      case EDIT_ENQUIRY_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_ENQUIRY_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_ENQUIRY:
        draft.isDeleting = true;
        break;
      case DELETE_ENQUIRY_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_ENQUIRY_FAILURE:
        draft.isDeleting = false;
        break;
      // Delete Note
      case DELETE_ENQUIRY_NOTE:
        draft.isDeleting = true;
        break;
      case DELETE_ENQUIRY_NOTE_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_ENQUIRY_NOTE_FAILURE:
        draft.isDeleting = false;
        break;
      // Delete Reminder Note
      case DELETE_ENQUIRY_REMINDER_NOTE:
        draft.isDeleting = true;
        break;
      case DELETE_ENQUIRY_REMINDER_NOTE_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_ENQUIRY_REMINDER_NOTE_FAILURE:
        draft.isDeleting = false;
        break;
      // NOTE OPEN
      case OPEN_NOTE_ADD_MODAL:
        draft.isNoteAddModalOpen = true;
        break;
      case CLOSE_NOTE_ADD_MODAL:
        draft.isNoteAddModalOpen = false;
        break;
      // REMINDER OPEN
      case OPEN_REMINDER_ADD_MODAL:
        draft.isReminderAddModalOpen = true;
        break;
      case CLOSE_REMINDER_ADD_MODAL:
        draft.isReminderAddModalOpen = false;
        break;
      case ADD_NOTE:
        draft.isSubmitting = true;
        break;
      case ADD_NOTE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_NOTE_FAILURE:
        draft.isSubmitting = false;
        break;
      // List
      case GET_NOTES:
        draft.isFetchingEnquiriesNotes = true;
        draft.currentEnquiryNote = {};
        break;
      case GET_NOTES_SUCCESS:
        draft.isFetchingEnquiriesNotes = false;
        draft.enquiriesNotes = action.payload;
        break;
      case GET_NOTES_FAILURE:
        draft.isFetchingEnquiriesNotes = false;
        break;
      case ADD_REMINDER:
        draft.isSubmitting = true;
        break;
      case ADD_REMINDER_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_REMINDER_FAILURE:
        draft.isSubmitting = false;
        break;
      // List
      case GET_REMINDERS:
        draft.isFetchingEnquiriesReminders = true;
        draft.currentEnquiryReminder = {};
        break;
      case GET_REMINDERS_SUCCESS:
        draft.isFetchingEnquiriesReminders = false;
        draft.enquiriesReminders = action.payload;
        break;
      case GET_REMINDERS_FAILURE:
        draft.isFetchingEnquiriesReminders = false;
        break;

      case GET_TIMELINE:
        draft.isFetchingTimeline = true;
        draft.currentTimeline = [];
        break;
      case GET_TIMELINE_SUCCESS:
        draft.isFetchingTimeline = false;
        draft.currentTimeline = action.payload;
        break;
      case GET_TIMELINE_FAILURE:
        draft.isFetchingTimeline = false;
        draft.currentTimeline = [];
        break;

      case TOGGLE_EVENT_MODAL:
        draft.eventModal = action.payload;
        break;

      case ADD_EVENT:
        draft.isAddingEvent = true;
        break;
      case ADD_EVENT_SUCCESS:
        draft.isAddingEvent = false;
        break;
      case ADD_EVENT_FAILURE:
        draft.isAddingEvent = false;
        break;

      case GET_STATS:
        draft.isGettingStats = true;
        draft.stats = {};
        break;
      case GET_STATS_SUCCESS:
        draft.isGettingStats = false;
        draft.stats = action.payload;
        break;
      case GET_STATS_FAILURE:
        draft.isGettingStats = false;
        draft.stats = {};
        break;

      case TOGGLE_ADDRESS_MODAL:
        draft.addressModal = action.payload;
        break;
      case TOGGLE_ATTORNEY_MODAL:
        draft.attorneyModal = action.payload;
        break;
      case TOGGLE_ASSIGN_MODAL:
        draft.assignModal = action.payload;
        break;

      case TOGGLE_SCHEDULE_MODAL:
        draft.scheduleModal = action.payload;
        break;
      case TOGGLE_OUTCOME_MODAL:
        draft.outcomeModal = action.payload;
        break;
      case TOGGLE_REMINDER_MODAL:
        draft.reminderModal = action.payload;
        break;
      case TOGGLE_CLOSE_MODAL:
        draft.closeModal = action.payload;
        break;
      case TOGGLE_DOC_MODAL:
        draft.docModal = action.payload;
        break;
      case TOGGLE_OTHER_MODAL:
        draft.otherModal = action.payload;
        break;
      case TOGGLE_EXIST_MODAL:
        draft.existModal = action.payload;
        break;

      case SAVE_DOCS:
        draft.isSavingDocs = true;
        break;
      case SAVE_DOCS_SUCCESS:
        draft.isSavingDocs = false;
        break;
      case SAVE_DOCS_FAILURE:
        draft.isSavingDocs = false;
        break;

      case SAVE_OUTCOME:
        draft.isSavingOutcome = true;
        break;
      case SAVE_OUTCOME_SUCCESS:
        draft.isSavingOutcome = false;
        break;
      case SAVE_OUTCOME_FAILURE:
        draft.isSavingOutcome = false;
        break;

      case SAVE_CLOSE:
        draft.isSavingClose = true;
        break;
      case SAVE_CLOSE_SUCCESS:
        draft.isSavingClose = false;
        break;
      case SAVE_CLOSE_FAILURE:
        draft.isSavingClose = false;
        break;

      case SET_VIEW:
        draft.view = action.payload;
        break;

      case SEARCH_CONTACT:
        draft.isSearchingContacts = true;
        draft.contactList = [];
        break;
      case SEARCH_CONTACT_SUCCESS:
        draft.contactList = action.payload;
        draft.isSearchingContacts = false;
        break;
      case SEARCH_CONTACT_FAILURE:
        draft.isSearchingContacts = false;
        draft.contactList = [];
        break;

      case SEARCH_EMAIL:
        draft.isSearchingEmail = true;
        draft.emailList = [];
        break;
      case SEARCH_EMAIL_SUCCESS:
        draft.emailList = action.payload;
        draft.isSearchingEmail = false;
        break;
      case SEARCH_EMAIL_FAILURE:
        draft.isSearchingEmail = false;
        draft.emailList = [];
        break;

      case EDIT_OUTCOME:
        draft.isEditingOutcome = true;
        break;
      case EDIT_OUTCOME_SUCCESS:
        draft.emailList = action.payload;
        break;
      case EDIT_OUTCOME_FAILURE:
        draft.isEditingOutcome = false;
        break;

      case GET_ENQ_CHART:
        draft.isGettingChart = true;
        draft.enqChart = {};
        break;
      case GET_ENQ_CHART_SUCCESS:
        draft.isGettingChart = false;
        draft.enqChart = action.payload;
        break;
      case GET_ENQ_CHART_FAILURE:
        draft.isGettingChart = false;
        draft.enqChart = {};
        break;

      case GET_CL_REPORT:
        draft.isGettingCL = true;
        draft.closeReport = {};
        break;
      case GET_CL_REPORT_SUCCESS:
        draft.isGettingCL = false;
        draft.closeReport = action.payload;
        break;
      case GET_CL_REPORT_FAILURE:
        draft.isGettingCL = false;
        draft.closeReport = {};
        break;

      case GET_AQ_REPORT:
        draft.isGettingAq = true;
        draft.aqReport = {};
        draft.refTypeReport = {};
        draft.refReport = [];
        draft.reportStage = {
          list: [],
          type: "default",
        };
        break;
      case GET_AQ_REPORT_SUCCESS:
        draft.isGettingAq = false;
        draft.aqReport = action.payload;
        break;
      case GET_AQ_REPORT_FAILURE:
        draft.isGettingAq = false;
        draft.aqReport = {};
        break;

      case GET_REF_REPORT:
        draft.isGettingRef = true;
        draft.refReport = [];
        draft.refTypeReport = {};
        draft.refReport = [];
        draft.reportStage = {
          list: [],
          type: "default",
        };
        break;
      case GET_REF_REPORT_SUCCESS:
        draft.isGettingRef = false;
        draft.refReport = action.payload;
        break;
      case GET_REF_REPORT_FAILURE:
        draft.isGettingRef = false;
        draft.refReport = [];
        break;
      case SET_REPORT:
        draft.reportStage = action.payload;
        break;

      case GET_TYPE_REPORT:
        draft.isGettingRef = true;
        break;
      case GET_TYPE_REPORT_SUCCESS:
        draft.isGettingRef = false;
        draft.refTypeReport = action.payload;
        break;
      case GET_TYPE_REPORT_FAILURE:
        draft.isGettingRef = false;
        break;

      case GET_MAP_REPORT:
        draft.isGettingMap = true;
        draft.mapReport = [];
        break;
      case GET_MAP_REPORT_SUCCESS:
        draft.isGettingMap = false;
        draft.mapReport = action.payload;
        break;
      case GET_MAP_REPORT_FAILURE:
        draft.isGettingMap = false;
        draft.mapReport = [];
        break;

      case GET_MY_TASK:
        draft.isGettingTask = true;
        draft.myTask = [];
        break;
      case GET_MY_TASK_SUCCESS:
        draft.isGettingTask = false;
        draft.myTask = action.payload;
        break;
      case GET_MY_TASK_FAILURE:
        draft.isGettingTask = false;
        draft.myTask = [];
        break;

      case SEARCH_USER:
        draft.isSearchingUser = true;
        draft.userList = [];
        break;
      case SEARCH_USER_SUCCESS:
        draft.isSearchingUser = false;
        draft.userList = action.payload;
        break;
      case SEARCH_USER_FAILURE:
        draft.isSearchingUser = false;
        draft.userList = [];
        break;

      case GET_COUNTY:
        draft.isGettingCounty = true;
        draft.countyList = [];
        break;
      case GET_COUNTY_SUCCESS:
        draft.isGettingCounty = false;
        draft.countyList = action.payload;
        break;
      case GET_COUNTY_FAILURE:
        draft.isGettingCounty = false;
        draft.countyList = [];
        break;

      case UPDATE_DONE:
        draft.isUpdatingDone = true;
        break;
      case UPDATE_DONE_SUCCESS:
        draft.isUpdatingDone = false;
        break;
      case UPDATE_DONE_FAILURE:
        draft.isUpdatingDone = false;
        break;

      case SET_DIGITAL_DATA:
        draft.digitalData = action.payload;
        break;
      case SET_RECOMM_DATA:
        draft.recommData = action.payload;
        break;
      case SET_LOCAL_DATA:
        draft.localData = action.payload;
        break;
      case SET_ADVERT_DATA:
        draft.advertData = action.payload;
        break;

      default:
        return state;
    }
  });

export default EnquiriesReducer;
